import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MyAccountMiniWidgetLoginClasses,
} from '@dxp-module/themes'

const miniWidgetLoginStyles = makeStyles<
  MyAccountTheme,
  Record<string, never>,
  MyAccountMiniWidgetLoginClasses
>(
  ({ palette }) => ({
    root: {},
    button: {},
    input: {
      padding: '8px 16px 3px 16px',
    },
    passwordIconButton: {
      padding: 0,
      margin: '0 10px',
    },
    inputLabel: {
      color: palette.text.third,
    },
  }),
  { name: 'MyAccount_MiniWidgetLogin' }
)

export default miniWidgetLoginStyles
